import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SEO = () => {
  const location = useLocation();
  const baseUrl = 'https://parisparihub.com';

  useEffect(() => {
    // Schema.org JSON-LD for Organization
    const organizationSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "ParisPari Hub",
      "url": "https://parisparihub.com",
      "logo": "https://parisparihub.com/images/favicon.webp",
      "description": "Guide expert pour les meilleurs sites de paris en ligne en France",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Paris",
        "addressCountry": "FR"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+33-4-12-40-70-11",
        "contactType": "customer service",
        "email": "info@parisparihub.com",
        "areaServed": "FR",
        "availableLanguage": "French"
      },
      "sameAs": []
    };

    // Schema.org JSON-LD for WebSite
    const websiteSchema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "ParisPari Hub",
      "url": "https://parisparihub.com",
      "description": "Guide expert pour les meilleurs sites de paris en ligne en France",
      "publisher": {
        "@type": "Organization",
        "name": "ParisPari Hub"
      },
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": "https://parisparihub.com/search?q={search_term_string}"
        },
        "query-input": "required name=search_term_string"
      }
    };

    // Schema.org JSON-LD for BreadcrumbList (if on a subpage)
    const getBreadcrumbSchema = () => {
      if (location.pathname === '/') return null;
      
      const paths = location.pathname.split('/').filter(p => p);
      const breadcrumbs = [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Accueil",
          "item": baseUrl
        }
      ];

      let currentPath = '';
      paths.forEach((path, index) => {
        currentPath += `/${path}`;
        breadcrumbs.push({
          "@type": "ListItem",
          "position": index + 2,
          "name": path.charAt(0).toUpperCase() + path.slice(1).replace(/-/g, ' '),
          "item": `${baseUrl}${currentPath}`
        });
      });

      return {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": breadcrumbs
      };
    };

    const breadcrumbSchema = getBreadcrumbSchema();

    // Remove existing schema scripts
    const existingScripts = document.querySelectorAll('script[type="application/ld+json"]');
    existingScripts.forEach(script => script.remove());

    // Add Organization schema
    const orgScript = document.createElement('script');
    orgScript.type = 'application/ld+json';
    orgScript.text = JSON.stringify(organizationSchema);
    document.head.appendChild(orgScript);

    // Add WebSite schema
    const websiteScript = document.createElement('script');
    websiteScript.type = 'application/ld+json';
    websiteScript.text = JSON.stringify(websiteSchema);
    document.head.appendChild(websiteScript);

    // Add Breadcrumb schema if needed
    if (breadcrumbSchema) {
      const breadcrumbScript = document.createElement('script');
      breadcrumbScript.type = 'application/ld+json';
      breadcrumbScript.text = JSON.stringify(breadcrumbSchema);
      document.head.appendChild(breadcrumbScript);
    }

    // Cleanup function
    return () => {
      const scripts = document.querySelectorAll('script[type="application/ld+json"]');
      scripts.forEach(script => {
        if (script.text.includes('"@type":"Organization"') || 
            script.text.includes('"@type":"WebSite"') || 
            script.text.includes('"@type":"BreadcrumbList"')) {
          script.remove();
        }
      });
    };
  }, [location.pathname]);

  return null;
};

export default SEO;

